<template>
  <div v-if="!onlyShowDate">
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-3 lbl">
            <label>Entité:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="entite"
                :options="entiteLibelles"
                optionValue="valeur"
                optionLabel="texte"
                v-on:keyup.enter="imprimer"
                scrollHeight="700px"
                :showClear="true"
            />
          </div>
        </div>
      </div>
      <div class="col">
        <div class="row">
          <div class="col-lg-3 lbl">
            <label>Site d'origine:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="siteOrigine"
                :options="sitesLibelles"
                optionValue="valeur"
                optionLabel="texte"
                @:keyup.enter="imprimer"
                scrollHeight="205px"
                :showClear="true"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-3 lbl">
            <label>Genre:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="genre"
                :options="genresLibelles"
                optionValue="valeur"
                optionLabel="texte"
                @:keyup.enter="imprimer"
                scrollHeight="205px"
                :showClear="true"
            />
          </div>
        </div>
      </div>
      <div v-if="showFonde" class="col">
        <div class="row">
          <div class="col-lg-3 lbl">
            <label>Fondé:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="fonde"
                :options="fondeLibelles"
                optionValue="valeur"
                optionLabel="texte"
                v-on:keyup.enter="imprimer"
                scrollHeight="700px"
                :showClear="true"
            />
          </div>
        </div>
      </div>
      <div v-else class="col"></div>
    </div>

    <div v-if="showNature" class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-3 lbl">
            <label>Nature:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="nature"
                :options="naturesLibelles"
                optionValue="valeur"
                optionLabel="texte"
                @:keyup.enter="imprimer"
                scrollHeight="205px"
                :showClear="true"/>
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>

    <div v-if="showType" class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-3 lbl">
            <label>Type:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="type"
                :options="typeLibelles"
                optionValue="valeur"
                optionLabel="texte"
                v-on:keyup.enter="imprimer"
                scrollHeight="700px"
                :showClear="true"
            />
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>

    <div v-if="showCategorie" class="row">
      <div class="col">
        <div class="row">
          <div class="col-lg-3 lbl">
            <label>Catégorie:</label>
          </div>
          <div class="col-lg-9">
            <Dropdown
                class="input-width-100"
                v-model="categorie"
                :options="categorieLibelles"
                optionValue="valeur"
                optionLabel="texte"
                v-on:keyup.enter="imprimer"
                scrollHeight="700px"
                :showClear="true"
            />
          </div>
        </div>
      </div>
      <div class="col"></div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Du:</label>
        </div>
        <div class="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateDu"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <label>Au:</label>
        </div>
        <div class="col-lg-9">
          <CustomInputDate
              class="input-width-100"
              type="date"
              max="9999-12-31"
              v-model="dateAu"
              v-on:keyup.enter="imprimer"
          />
        </div>
      </div>
    </div>
  </div>

  <div v-if="showRegroupement" class="row">
    <div class="col">
      <div class="row">
        <div class="col-lg-3 lbl">
          <!-- TODO NATHAN trouver l'appel pour regroupement endroit -->
          <label>Regroupement des endroits:</label>
        </div>
        <div class="col-lg-9">
          <Dropdown
              class="input-width-100"
              v-model="regroupement"
              :options="regroupementLibelles"
              optionValue="valeur"
              optionLabel="texte"
              v-on:keyup.enter="imprimer"
              scrollHeight="700px"
              :showClear="true"
          />
        </div>
      </div>
    </div>
    <div class="col"></div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import CustomInputDate from '../../Commun/CustomInputDate.vue'

export default {
  name: "CritereRechercheStatistiques",
  emits: ['imprimer'],
  components: {
    CustomInputDate
  },
  props: {
    showRegroupement: {
      type: Boolean,
      default: false,
    },
    showFonde: {
      type: Boolean,
      default: true,
    },
    showType: {
      type: Boolean,
      default: true,
    },
    showNature: {
      type: Boolean,
      default: true,
    },
    showCategorie: {
      type: Boolean,
      default: true,
    },
    onlyShowDate: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      titre: null,
      entite: null,
      siteOrigine: null,
      genre: null,
      nature: null,
      type: null,
      categorie: null,
      fonde: null,
      dateDu: null,
      dateAu: null,
      regroupement: null,

      entiteLibelles: [],
      sitesLibelles: [],
      genresLibelles: [],
      naturesLibelles: [],
      typeLibelles: [],
      categorieLibelles: [],
      fondeLibelles: [],
      regroupementLibelles: [],

      intervenantsLoading: false,
      critereRecherche: {}
    };
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  methods: {
    assignerListe(entiteDecision) {
      this.entiteLibelles = entiteDecision.entite.libelles;
      this.fondeLibelles = entiteDecision.fonde.libelles;
      this.$store.dispatch("dossier/obtenirSiteEntiteAction").then((res) => {
        this.entite = res.data.entite;
        this.siteOrigine = res.data.site;
        this.dateDefault();
      });
    },
    dateDefault() {
      let dateDefaut = new Date();
      this.dateDu = this.$commun.formatDate(dateDefaut.setDate(dateDefaut.getDate() - 30));
      this.dateAu = this.$commun.formatDate(new Date());
    },
    getCritereRecherche() {
      if (this.dateAu !== null && this.dateAu !== undefined) {
        this.critereRecherche.dateAu = new Date(this.dateAu);
      }
      if (this.dateDu !== null && this.dateDu !== undefined) {
        this.critereRecherche.dateDu = new Date(this.dateDu);
      }

      this.critereRecherche.titre = this.titre;
      this.critereRecherche.entite = this.entite;
      this.critereRecherche.fonde = this.fonde;
      this.critereRecherche.genre = this.genre;
      this.critereRecherche.nature = this.nature;
      this.critereRecherche.siteOrigine = this.siteOrigine;
      this.critereRecherche.type = this.type;
      return this.critereRecherche;
    },
    imprimer() {
      this.$emit("imprimer");
    },
  },
  watch: {
    entite: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch("dossier/onChangeEntityAction", {
          libelleChange: 'Site',
          nouvelleValeur: [val]
        })
            .then((res) => {
              this.sitesLibelles = res.data;
            });
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Genre',
          nouvelleValeur: val
        })
            .then((res) => {
              this.genresLibelles = res.data;
            });
      } else {
        this.genre = null;
        this.genresLibelles = [];
        this.siteOrigine = null;
        this.sitesLibelles = [];
      }
    },
    siteOrigine: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirEndroitLocalisationParSiteAction', {
          site: val
        })
            .then((res) => {
              this.endroitLibelles = res.data.endroit;
              this.localisationLibelles = res.data.localisation;
            });
      } else {
        this.endroitLibelles = [];
        this.endroit = null;
        this.localisationLibelles = [];
        this.localisation = null;
      }
    },
    genre: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Nature',
          nouvelleValeur: val
        })
            .then((res) => {
              this.naturesLibelles = res.data;
            });
      } else {
        this.nature = null;
        this.naturesLibelles = [];
      }
    },
    nature: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Type',
          nouvelleValeur: val
        })
            .then((res) => {
              this.typeLibelles = res.data;
            });
      } else {
        this.type = null;
        this.typeLibelles = [];
      }
    },
    type: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Categorie',
          nouvelleValeur: val
        })
            .then((res) => {
              this.categorieLibelles = res.data;
            });
      } else {
        this.categorie = null;
        this.categorieLibelles = [];
      }
    },
    secteur: function (val) {
      if (val !== null && val !== undefined) {
        this.intervenantsLoading = true;
        this.$store.dispatch('dossier/obtenirListeIntervenantsAction', {
          secteur: val
        })
            .then((res) => {
              this.intervenantLibelles = res.data.sort(this.$commun.compareIntervenant);
              this.intervenantsLoading = false;
            });
      } else {
        this.intervenant = null;
      }
    },
  }
}
</script>